module.exports = __webpack_public_path__ + "img/poster-banner.a829365d.svg";